import React from 'react';
import { Container, Header } from 'semantic-ui-react';
import { FormattedMessage } from 'react-intl';
import LookupVocabularyTable from '../../lookups/components/LookupVocabularyTable';
import DictionaryLookupSettings from '../../lookups/containers/DictionaryLookupSettings';

const FieldInformation = ({
  field,
  lookups,
  canEdit,
  errors,
  validationWarnings,
}) => {
  const { constraints } = field || { constraints: null };
  const lookupItems = constraints ? lookups[constraints] : null;

  return (
    <>
      {field
      && (
      <Container fluid className="aridhia-description">
        {field.description}
      </Container>
      )}
      {lookupItems && (
        <>
          <Header as="h4" className="font-weight-dark">
            <FormattedMessage id="dictionary.vocabulary.header" />
          </Header>
          <DictionaryLookupSettings />
          <LookupVocabularyTable
            className="field"
            lookupItems={lookupItems}
            canEdit={canEdit}
            lookupName={constraints}
            errors={errors}
            validationWarnings={validationWarnings}
          />
        </>
      )}
    </>
  );
};

export default FieldInformation;
